/**
 * Calculate what percentage number A is of number B
 * @param {number} numberA
 * @param {number} numberB
 * @returns {string} The percentage in a fixed-point notation
 */
export const getPercentage = (numberA, numberB) => ((100 * numberA) / numberB).toFixed(0);
